import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { UserData } from '@thiememeulenhoff/types';
import { UserUnifiedEndpointService } from './user-unified.endpoint.service';

@Injectable({
  providedIn: 'root',
})
export class UserUnifiedService {
  readonly #http = inject(HttpClient);

  readonly #endpoints = inject(UserUnifiedEndpointService);

  fetchUserData() {
    const endpoint = this.#endpoints.fetchUserData();

    return this.#http.get<UserData>(endpoint);
  }
}
